import { Component } from '@angular/core';

@Component({
    selector: 'hvac-accordion-header',
    templateUrl: './accordion-header.component.html',
    styleUrls: ['./accordion-header.component.scss']
})
export class AccordionHeaderComponent {
}
